import React from 'react'; import ExtendedModulePage from './ExtendedModulePage'; export default function TransportRoutesPage(){return <ExtendedModulePage moduleKey="transport-routes"/>}
